<template>
  <div id="search">
    <!-- header part -->
    <my-header2></my-header2>
    <!-- article mian part -->
    <div id="article-main">
      <div class="container">
        <!-- catalog left and right part -->
        <div class="row p-3">

          <!-- catalgo right -->
          <div class="col-sm-6 col-lg-9 bg-white">
            <!-- breadcrumb part -->
            <ol class="breadcrumb bg-white">
              <li class="breadcrumb-item"><a href="/">首页</a></li>
              <li class="breadcrumb-item">文章搜索</li>
              <li class="breadcrumb-item active" aria-current="page">"{{skey}}"</li>
            </ol>

            <div v-if="isNull">
              <!-- catalog list part -->
              <ul class="list-group catalog-list">
                <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(item,index) in articles" :key="item.id">
                  <a :href="detailUrl + item.id">{{item.title}}</a>
                  <span class="badge">{{getPartTimeYmd(item.createTime)}}</span>
                </li>
              </ul>
              <!-- pagination part -->
              <nav aria-label="Page navigation example" class="m-5">
                <ul class="pagination justify-content-center pagination-sm">
                  <li class="page-item"><a class="page-link" href="javascript:void(0);" @click="switchToPage(1)" aria-label="Previous">首页</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0);" @click="switchToPage(currPage-1)" aria-label="Previous"> <span aria-hidden="true">&laquo;</span> <span class="sr-only">Previous</span> </a> </li>
                  <li class="page-item" v-for="index in pages" :key="" :class="{active:index==currPage}"><a class="page-link" href="javascript:void(0);" @click="switchToPage(index)">{{index}}</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0);" @click="switchToPage(currPage+1)" aria-label="Next"> <span aria-hidden="true">&raquo;</span> <span class="sr-only">Next</span> </a> </li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0);" @click="switchToPage(pages)" aria-label="Previous">尾页</a></li>
                </ul>
              </nav>
            </div>
            <div class="text-center small" v-else>
              暂无记录！
            </div>

          </div>

          <!-- catalog left -->
          <div class="col-sm-6 col-lg-3 d-none d-md-block" id="catalog-left">
            <h4 class="m-0 p-3 text-center text-white catalog-hd">文章搜索</h4>
            <p class="m-0"><img src="/static/img/catalog/catalog-banner.png" width="100%"></p>
            <my-sidebar></my-sidebar>
          </div>

        </div>
      </div>
    </div>
    <!-- footer part -->
    <my-footer></my-footer>
  </div>
</template>
<script>


import header from '@/views/header/header';
import footer from '@/views/footer/footer';
import header2 from '@/views/header/header2';
import sidebar from '@/views/sidebar/sidebar';

const axios = require('axios');

export default {
  name: 'search',
  components: {
    'my-header': header,
    'my-footer': footer,
    'my-header2': header2,
    'my-sidebar': sidebar
  },
  data() {
    return {
      skey: null,
      isNull: false,
      articles: [{'id':'', 'title':'', 'createTime':''}],
      currPage: 1,
      pageSize: 20,
      pages: 0,
      total: 0,
      detailUrl: '/article/details/',
      categoryUrl: '/article/category/'
    }
  },
  created() {
    const skey = this.$route.params.skey;
    this.skey = skey;
  },
  mounted () {
    let that = this;
    that.getCategoryList();
  },
  watch: {
    // 重复点击路由时重新加载
    $route(){
      const skey = this.$route.params.skey;
      this.skey = skey;
      this.getCategoryList();
    }
  },
  methods:{
    // 获取文章列表
    getCategoryList: function () {
      let that = this;
      // 文章列表
      axios.get(that.global.apiUrl + '/web/article/list?page=' + that.currPage +'&limit=' + that.pageSize +'&sort=id&order=desc&title='+that.skey)
        .then(function (response) {
          if (response.data.success && response.data.data.records.length > 0) {
            that.isNull = true
            that.articles = response.data.data.records;
            that.total = response.data.data.total
            that.pages = response.data.data.pages
          }else if (response.data.success && response.data.data.records.length == 0){
            that.isNull = false
          }else {
            that.$router.push({ name: 'page404'});
          }
      });
    },

    // 分页
    switchToPage: function (page) {
      console.log(page)
      if (page < 1 || page > this.pages){
          return false;
      }
      this.currPage = page;
      this.getCategoryList();
    },

    getPartTimeForDate:function (val) {
      var timearr = val.replace(" ", ":").replace(/\:/g, "-").split("-");
      var timestr = ""+ Number(timearr[1])+ "月" + timearr[2]+"日";
      return timestr;
    },
    getPartTimeYmd: function (val) {
      //let ti = val.split(' ');
      var timearr = val.split(" ");
      var timestr = ""+ timearr[0];
      return timestr;
    }

  }
};

</script>

<style>
  #article-main {
    background-color: #ecf2f6;
  }
  .catalog-hd {
    /* background-color: #8B0000; */
    /* background-color: #2092c8; */
     /* background-image: radial-gradient(circle, #104883, #022952); */
     background-color: #0050a5!important;
  }
  #catalog-left h4 {
    font-size: 1.2rem;
  }
  .catalog-list-group {
    border-top: 0!important;
    border-radius: 0;
  }
  .catalog-list-group li:hover {
    /* background-color: #8B0000; */
    background-color: #0069D9;
    /* background-color: #0050a5; */
    color: #FFFFFF;
  }
  .catalog-list-group li:hover a {
    color: #FFFFFF;
    text-decoration: none;
  }
  .liactive {
      z-index: 2;
      color: #FFFFFF!important;
      /* background-color: #8B0000!important; */
      background-color: #0050a5!important;
      /* border-color: #8B0000!important; */
      /* border-color: #0050a5!important; */
      /* background-image: radial-gradient(circle, #104883, #022952); */
      border-color: #104883!important;
  }
  .liactive a {
    color: #FFFFFF;
  }
  .breadcrumb {
    /* background-color: #FFFFFF; */
    font-size: 14px;
    border-bottom: 1px #ccc solid;
    border-radius: 0;
  }
  .catalog-list {
    border: 0!important;
  }
  .catalog-list .list-group-item {
    border: 0;
    background: url(/static/images/icon/icon-list.png) no-repeat left center;
    border-bottom: 1px #ccc dotted;
  }
  .catalog-list .list-group-item a {
    color: #333333;
  }
  .catalog-list .badge {
    color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/views/search/search.vue